export default __webpack_public_path__ + "static/media/Fondo-Banner-Principal.40b9e8c8.jpg";